import React from 'react';
import { Typography, Chip } from '@mui/material';

/**
 * Priority colors mapping
 */
const priorityColors: Record<string, { backgroundColor: string; color: string }> = {
  High: { backgroundColor: '#fee2e2', color: '#dc2626' },
  Medium: { backgroundColor: '#fef3c7', color: '#d97706' },
  Low: { backgroundColor: '#f3f4f6', color: '#374151' },
};

/**
 * Priority chip template
 */
export const PriorityChipTemplate: React.FC<{ priority?: string }> = ({ priority }) => {
  if (!priority) {
    return (
      <Typography variant="body2" sx={{ color: '#94a3b8' }}>
        -
      </Typography>
    );
  }

  const priorityColor = priorityColors[priority] || { backgroundColor: '#f3f4f6', color: '#374151' };

  return <Chip label={priority} size="small" sx={priorityColor} />;
};

export default PriorityChipTemplate;
